module.exports = "<template> <sio-translatable-image field.bind=field value.bind=field.value> </sio-translatable-image> </template> ";